import ItemTypeBaseController from '../common/item_type.base.controller'
import AppConstants from '../../../config/app.constants';

class ItemTypeCreateController extends ItemTypeBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams) {

		super(Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams)
		this.ItemTypeService = ItemTypeService;
		this.user = User;
		this.hasACL = {};
		this.defaultModel = {
			label: null,
			loading: false
		}
		this.model = angular.copy(this.defaultModel);
	}

	$onInit() {}

	reset() {
		this.model = angular.copy(this.defaultModel);
        this.clearErrors();
	}

	submit() {
		this.model.loading = true;
		this.Service.create({
			label: this.model.label
		})
			.then(() => {
				this.askCreate();
			})
			.catch((err) => {
				err.data.errors.map((e) => {
					this.model.errorMessage += e.message + '<br/>'
				})
			})
			.finally(() => {
				this.model.loading = false;
			})
	}

}

export default ItemTypeCreateController;


// WEBPACK FOOTER //
// ./client/app/components/item_type/create/item_type.create.controller.js